export const environment = {
  production: false,
  // TODO: Update this to the dev URL
  api: "https://t3tkvuugzi.execute-api.us-east-2.amazonaws.com/prod/",
  mixpanel: {
    token: '524e35860a202abd43f9ec414ebaf09e',
  }
};
